export default __webpack_public_path__ + "static/media/rabbit-gun-3.7d68f86b.png";